<div class="modal-header">
    <h4 class="modal-title">
        Toplu Mesai Saatini Ekleme
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <label for="datePicker">Tarih Seçin:</label>
    <ng2-flatpickr [config]="dateTimeOptions" [(ngModel)]="selectedDate" [setDate]="date"></ng2-flatpickr>
</div>

<div class="modal-footer">
    <button class="btn btn-primary" (click)="assignWorkPoints()">Kaydet</button>
</div>